module.exports = __webpack_public_path__ + "assets/color-wheel.08a2a009.svg";